import { useEffect, useState } from 'react';

const THEME_KEY = 'student_theme';

type Theme = 'light' | 'dark';

function getInitialTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch { /* ignore */ }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/**
 * Hell/Dunkel-Umschaltung für den Schülerbereich.
 * Die Wahl wird in localStorage gespeichert; ohne gespeicherte Wahl
 * gilt die Systemeinstellung.
 */
export function useStudentTheme() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    try { localStorage.setItem(THEME_KEY, theme); } catch { /* ignore */ }
  }, [theme]);

  const toggleTheme = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));

  return { theme, isDark: theme === 'dark', toggleTheme };
}
